module.exports = __webpack_public_path__ + "static/img/navbar_bg.02774e82.png";